export const url = '/api/user-preferences';
